/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2015, 2017
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define(['jquery', './Input'],
	function($, Input) {

		var SearchInput = null;

		SearchInput = Input.extend({

			init : function() {
				SearchInput.inherited('init', this, arguments);

				this.$input.on('input', function(){
					this.$el.toggleClass('hasContent', this.$input.val() !== '');
				}.bind(this));

			},

			_clearContent: function() {
				this.$el.removeClass('hasContent');
				this.$input.val('');
			},

			clear: function(){
				this._clearContent();
				SearchInput.inherited('clear', this, arguments);
			},

			render: function(){
				this.$el.addClass('searchInput');
				SearchInput.inherited('render', this, arguments);
				this.$el.prepend('<div class="searchIcon wfg_search"></div>');
				this.$close = $('<div class="closeIcon wfg_close"></div>');
				this.$close.on('click', this._clearContent.bind(this));
				this.$el.append(this.$close);

				return this;
			}
		});

		return SearchInput;
	});
